window.Reverb = window.Reverb || {};

/**
 * DO NOT REMOVE
 * This is used in frontend -> discovery-ui/src/components/offers/refresh_dashboard.ts
 */
window.Reverb.Badges = (function () {
  const globalBadge = '[rel=\'total_notifications_badge\']';

  function getCount(badge) {
    return +$(badge).attr('data-notification-count') || 0;
  }

  function setCount(badge, val) {
    return $(badge).attr('data-notification-count', val);
  }

  function changeCount(badge, change) {
    let count = getCount(badge);
    setCount(badge, count += change);

    if (getCount(badge) <= 0) {
      $(badge).removeAttr('data-notification-count');
    }
  }

  function modifyBadge(badgeRel, change) {
    const badges = $(`[rel=${badgeRel}]`);

    badges.each((index, badge) => {
      changeCount(badge, change);
    });

    changeCount(globalBadge, change);
  }

  function decrementBadge(badgeRel) {
    modifyBadge(badgeRel, -1);
  }

  function incrementBadge(badgeRel) {
    modifyBadge(badgeRel, 1);
  }

  return {
    decrementBadge,
    incrementBadge,
  };
}());
